import { Avatar, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleClose } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ICloseSearch {
  closeAdvancedSearch: Function;
}

export const CloseSearch = ({ closeAdvancedSearch }: ICloseSearch) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicalReferrals)
    .search.advancedSearch;

  return (
    <Box
      position='absolute'
      bgcolor='primary.shade_100'
      borderRadius='16px 16px 0px 0px'
      right={0}
      top={0}
      gap={'4px'}
      display='flex'
      alignItems='center'
      padding='12px 32px 12px'
      sx={{
        cursor: 'pointer',
        transform: 'translate(0,-95%)',
        ':after': {
          background: 'primary.shade_100',
          height: '40px',
          content: '""',
          position: 'absolute',
          bottom: '-40px',
          left: '-20px',
          right: '0',
        },
      }}
      onClick={() => closeAdvancedSearch(false)}
      onKeyDown={onEnterOrEscapeKeyDown}
      tabIndex={0}
      aria-label={dictionary.ariaLabelClose}
    >
      <Avatar alt='' src={PurpleClose} sx={{ width: '32px', height: '32px' }} />
      <Typography variant={'body2'} color={'primary.main'}>
        {dictionary.close}
      </Typography>
    </Box>
  );
};
